import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["history"];

  connect() {
    console.log("Exercise history controller connected");
  }

  loadHistory(event) {
    const templateId = event.target.value;
    if (!templateId) {
      this.clearHistory();
      return;
    }

    fetch(`/exercise_history/${templateId}`)
      .then((response) => response.text())
      .then((html) => {
        document.getElementById("exercise-history").innerHTML = html;
      })
      .catch((error) => {
        console.error("Error loading exercise history:", error);
      });
  }

  clearHistory() {
    document.getElementById("exercise-history").innerHTML = "";
  }
}
